export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./InstagramFeed.vue?vue&type=template&id=17361328&"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/InstagramFeed.vue?vue&type=template&id=17361328&
// module id = 126
// module chunks = 7